export const FETCH_ERROR_LOGS = 'FETCH_ERROR_LOGS';
export const UPDATE_VALIDATION = 'UPDATE_VALIDATION';
export const FETCH_VALIDATIONS = 'FETCH_VALIDATIONS';
